import { App } from '@/apps'
import asyncThunk from '@/lib/asyncThunk'

type Request = {
  companyName: string
  annualCallVolume: string
  currentAuthenticationMethod: string
  apps: App[]
}

type Response = Record<never, never>

export const accountQuestionnaire = asyncThunk<Request, Response>({
  name: 'accounts/questionnaire',
  uri: '/accounts/questionnaire',
  method: 'PUT',
})
